import React, { useState } from 'react'
import { FormikValues, useFormik } from 'formik'
import * as Yup from 'yup'
import { addBookingAmount, generatePaymentLink, sendWhatsappPaymentLink } from '../LeadManagementAPI'

interface addBookingAmountDataType {
    setSaveFeedback: (saveFeedback: string | null) => void
    setScheduleVisit: (ScheduleVisit: string | null) => void
    setAddBookingAmt: (AddBookingAmt: string | null) => void
    getLeadList: () => void
    lead_property_booking_uuid: string
    setError: (error: string) => void
    setSuccessMsg: (successMsg: string | null) => void
}
const ViewLeadStep4 = ({
    acceptedProperty,
    setError,
    setSuccessMsg
}: any) => {
    const [saveAmountLoading, setSaveAmountLoading] = useState<boolean>(false)
    const [paymentLinkPresent, setPaymentLinkPresent] = useState<boolean>(false)
    const [isCopied, setIsCopied] = useState<boolean>(false)
    const [isSent, setIsSent] = useState<boolean>(false)

    // validation schema for save feedback
    const validationSchema = Yup.object().shape({
        amount: Yup.number()
            .typeError('Booking amount must be a number')
            .integer('Booking amount must be an integer')
            .positive('Booking amount must be a positive number')
            .min(1, 'Booking amount must be at least 1')
            .required('Booking amount is required'),
    })

    // function to save feedback
    //   const handleGeneratePaymentLink = async (values: FormikValues) => {
    //     setSaveAmountLoading(true)
    //     try {
    //       const {data: response} = await addBookingAmount(
    //         lead_property_booking_uuid,
    //         parseInt(values.amount, 10)
    //       )
    //       if (response.code === '200') {
    //         setPaymentLinkPresent(true)
    //         try {
    //           const {data: response} = await generatePaymentLink(lead_property_booking_uuid)
    //           if (response.code === '200') {
    //             formik.setFieldValue('payment_link', response.data, true)
    //             setSuccessMsg(`Success: Payment Link Generated Successfully!`)
    //           } else {
    //             setError(`Error: ${response.msg_details}`)
    //           }
    //         } catch (error: any) {
    //           setError(`Error: ${error}`)
    //         }
    //       } else {
    //         setError(`Error: ${response.msg_details}`)
    //       }
    //     } catch (error: any) {
    //       setError(`Error: ${error}`)
    //     } finally {
    //       setSaveAmountLoading(false)
    //     }
    //   }
    // function to save feedback
    const handleGeneratePaymentLink = async (values: FormikValues) => {
        if (acceptedProperty?.length > 0 && acceptedProperty[0]?.lead_booking_details?.lead_property_booking_uuid) {
            setSaveAmountLoading(true)
            try {
                const { data: response } = await addBookingAmount(
                    acceptedProperty[0]?.lead_booking_details?.lead_property_booking_uuid,
                    parseInt(values.amount, 10)
                )
                if (response.code === '200') {
                    setPaymentLinkPresent(true)
                    try {
                        const { data: response } = await generatePaymentLink(acceptedProperty[0]?.lead_booking_details?.lead_property_booking_uuid)
                        if (response.code === '200') {
                            formik.setFieldValue('payment_link', response.data, true)
                            setSuccessMsg(`Success: Payment Link Generated Successfully!`)
                        } else {
                            setError(`Error: ${response.msg_details}`)
                        }
                    } catch (error: any) {
                        setError(`Error: ${error}`)
                    }
                } else {
                    setError(`Error: ${response.msg_details}`)
                }
            } catch (error: any) {
                setError(`Error: ${error}`)
            } finally {
                setSaveAmountLoading(false)
            }
        }
    }
    // formik object for save feedback
    const formik = useFormik({
        initialValues: { amount: '', payment_link: '' },
        validationSchema,
        onSubmit: (values) => handleGeneratePaymentLink(values),
    })

    // function to copy to clipboard payment url
    const copyToClipboard = () => {
        if (formik.values.payment_link) {
            navigator.clipboard
                .writeText(formik.values.payment_link)
                .then(() => {
                    setIsCopied(true)
                    setTimeout(() => {
                        setIsCopied(false)
                    }, 3000)
                })
                .catch((error) => {
                    console.error('Failed to copy:', error)
                })
        }
    }

    const sendWhatsappPayment = async () => {
        if (formik.values.payment_link) {
            try {
                const { data: response } = await sendWhatsappPaymentLink(acceptedProperty[0]?.lead_booking_details?.lead_property_booking_uuid)
                if (response.code === '200') {
                    setIsSent(true);
                    setSuccessMsg(`Success: Message Sent Successfully!`)
                    setTimeout(() => {
                        setIsSent(false)
                    }, 3000)
                } else {
                    setError(`Error: ${response.msg_details}`)
                }
            } catch (error: any) {
                setError(`Error: ${error}`)
            }
        }
    }

    return (
        <div data-kt-stepper-element='content'>
            <table className='w-100'>
                <tbody>
                    <tr className='w-100'>
                        {paymentLinkPresent ? (
                            <td colSpan={5} className='p-0'>
                                <div className='d-flex justify-content-between'>
                                    {/* Begin: heading */}
                                    <h4>Copy Payment Link</h4>
                                    {/* End: heading */}
                                </div>
                                {/* Begin: Form */}
                                <form onSubmit={formik.handleSubmit}>
                                    <div className='row w-100'>
                                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                            <span>Payment Link</span>
                                            <i
                                                className='fas fa-exclamation-circle ms-2 fs-7'
                                                data-bs-toggle='tooltip'
                                                title='Copy payment link'
                                            ></i>
                                        </label>
                                        {/* Begin: form group Feedback */}
                                        <div className='fv-row col-lg-8 col-12'>
                                            <input
                                                type='text'
                                                className='form-control form-control-lg form-control-solid'
                                                placeholder='Copy payment link'
                                                {...formik.getFieldProps('payment_link')}
                                                name='payment_link'
                                            />
                                        </div>
                                        {/* End: form group Payment Link */}
                                        <div className='col-lg-4 col-12'>
                                            {/* Begin:: submit button */}
                                            <button
                                                type='button'
                                                onClick={copyToClipboard}
                                                className='btn btn-primary w-100'
                                                data-bs-toggle='modal'
                                                data-bs-target='#kt_modal_offer_a_deal'
                                            >
                                                {isCopied ? (
                                                    <i className='bi bi-clipboard-check me-2 my-0 p-0 fs-5'></i>
                                                ) : (
                                                    <i className='bi bi-clipboard me-2 my-0 p-0 fs-5'></i>
                                                )}
                                                <span>{isCopied ? 'Copied!' : 'Copy Payment Link'}</span>
                                            </button>
                                            {/* Begin:: submit button */}
                                        </div>
                                        <div className='row w-100 justify-content-end px-0'>
                                        <button
                                            type='button'
                                            onClick={sendWhatsappPayment} // Call the function on click
                                            className='btn btn-primary w-250px'
                                            data-bs-toggle='modal'
                                            data-bs-target='#kt_modal_offer_a_deal'
                                            >
                                            {isSent ? (
                                                <i className='bi bi-clipboard-check me-2 my-0 p-0 fs-5'></i>
                                            ) : (
                                                <i className='bi bi-clipboard me-2 my-0 p-0 fs-5'></i>
                                            )}
                                            <span>{isSent ? 'Message Sent' : 'Send on Whatsapp!'}</span>
                                            </button>

                                        </div>
                                    </div>
                                </form>
                                {/* End: Form */}
                            </td>
                        ) : (
                            <td colSpan={5} className='p-0'>
                                <div className='d-flex justify-content-between'>
                                    {/* Begin: heading */}
                                    <h4>Add Booking Amount</h4>
                                    {/* End: heading */}
                                </div>
                                {/* Begin: Form */}
                                <form onSubmit={formik.handleSubmit}>
                                    <div className='row w-100'>
                                        {/* Begin: form group Feedback */}
                                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                            <span>Booking Amount</span>
                                            <i
                                                className='fas fa-exclamation-circle ms-2 fs-7'
                                                data-bs-toggle='tooltip'
                                                title='Enter booking amount'
                                            ></i>
                                        </label>
                                        <div className='fv-row col-lg-8 col-12'>
                                            <input
                                                type='text'
                                                className='form-control form-control-lg form-control-solid'
                                                placeholder='Enter booking amount'
                                                {...formik.getFieldProps('amount')}
                                                name='amount'
                                            />
                                            <div className='h-20px'>
                                                {formik.touched.amount && formik.errors.amount && (
                                                    <div className='fv-help-block color-red'>
                                                        {formik.errors.amount.toString()}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-12'>
                                            <button className='btn btn-primary w-100'>Generate Payment Link</button>
                                        </div>
                                    </div>
                                </form>
                                {/* End: Form */}
                            </td>
                        )}
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ViewLeadStep4
